export const outerWidth = (el: HTMLElement) => {
  let width = el.offsetWidth;
  const style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};
